import { ConfigurationType, LevelType } from 'data/types';
import { rederivePtacUnits } from 'utils/ptac-configuration';

export function rederivePtacConfigurationIn(
  configurations: ConfigurationType[],
  previous: ConfigurationType,
  structure: LevelType[]
): ConfigurationType[] {
  return configurations.map((configuration) =>
    configuration.uniqueId === previous.uniqueId
      ? rederivePtacUnits(previous, configuration, structure)
      : configuration
  );
}
